import Vue from 'vue';
import App from './App.vue';
import '@/common/SysComponent.js';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
Vue.config.productionTip = false;

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

// 屏幕适配
import flexible from 'rem-flexible';
flexible(1920, 16);

import VueBus from 'vue-bus';
Vue.use(VueBus);

import 'vue2-animate/dist/vue2-animate.min.css';

import router from './router.js';
import myStore from './store/store.js';

new Vue({
  router,
  store: myStore,
  render: h => h(App)
}).$mount('#app');
